'use client';

import {QueryClientProvider, QueryClient} from '@tanstack/react-query';
import {memo, useState} from 'react';

const QueryContainer = ({children}) => {
  const [queryClient] = useState(() => new QueryClient());

  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
};

export default memo(QueryContainer);
